/**
 * dialog
 * @description: 浮出弹窗(Alert, Confirm), 配合UED的Dialog DPL定义实现.
 * @author: qin.lianq
 */

var $ = require('@alife/alpha-jquery/jquery'),
    mask = require('@alife/alpha-overlay/mask'),
    i18n = require('./src/i18n'),
    Buttons = require('./src/js/buttons'),
    Overlay = require('@alife/alpha-overlay/overlay'),
    Events = require('@alife/alpha-events/events'),
    UIState = require('@alife/alpha-mixin/ui-state'),
    KeyBinder = require('@alife/alpha-mixin/key-binder'),
    Animation = require('@alife/alpha-mixin/animation'),
    Util = require('@alife/alpha-util/log'),
    Templatable = require('@alife/alpha-templatable/templatable');

// 默认的button的map
var buttonMap = {
        'confirm': '<input type="button" value="{{confirm}}" class="ui2-button ui2-button-primary ui2-button-medium" data-role="confirm" />',
        'cancel': '<input type="button" value="{{cancel}}" class="ui2-button ui2-button-normal ui2-button-medium" data-role="cancel" />',
        'yes': '<input type="button" value="{{yes}}" class="ui2-button ui2-button-primary ui2-button-medium" data-role="yes" />',
        'no': '<input type="button" value="{{no}}" class="ui2-button ui2-button-normal ui2-button-medium" data-role="no" />'
    },
// 从Attrs中读取的Model部分
    setModelFromAttrs = ['hasCloseX', 'title', 'content', 'buttons', 'i18n', 'buttonPosition'];

var Dialog = Overlay.extend({

    Implements: [UIState, KeyBinder, Animation, Templatable, Buttons],

    attrs: {
        // 对话框触发点
        trigger: {
            value: null,
            getter: function (val) {
                return $(val);
            }
        },

        // 统一样式前缀
        classPrefix: 'ui2-dialog',

        // 指定内容元素，可以是 url 地址
        content: {
            value: null,
            setter: function (val) {
                // 判断是否是 url 地址
                if (/^(https?:\/\/|\/|\.\/|\.\.\/)/.test(val)) {
                    this._type = 'iframe';
                }
                return val;
            }
        },
        autoFocus: true,

        // 默认高度
        height: null,

        // iframe 类型时，dialog 的最初高度
        initialHeight: 300,

        // 不用解释了吧
        zIndex: 999,

        // 是否自适应高度
        autoFit: true,

        // 默认 width 修改，符合dpl要求
        width: 400,

        contentHeight: '100%',


        // iframe 自身是否允许滚动: yes, no, auto
        // iframe 的 scroll 只能通过 scrolling 属性控制
        iframeScrolling: 'no',

        // 定位方式
        align: {
            value: {
                selfXY: ['50%', '50%'],
                baseXY: ['50%', '50%']
            },
            getter: null
        },

        // 文案配置
        i18n: {
            value: i18n,
            setter: function (val) {
                return merge(i18n, val);
            }
        },

        /**
         * 按钮
         *
         * @attribute buttons
         * @type Array
         */
        buttons: {
            value: null,
            // 做button的格式化
            getter: function (val) {
                if (!this._buttons) {
                    this._buttons = this._convertButtons(val);
                }

                return this._buttons;
            },
            readOnly: true
        },

        // 按钮位置（左，中，右），默认居左
        buttonPosition: {
            value: null,
            getter: function (val) {
                switch (val) {
                    case 'left':
                        return 'util-align-left';
                    case 'center':
                        return 'util-align-center';
                    case 'right':
                        return 'util-align-right';
                }
            }
        },

        // 默认button及模板
        buttonMap: buttonMap,

        // 是否支持键盘事件，默认为true
        supportKeyEvents: true,

        // 默认都有关闭的按钮的
        hasCloseX: true,

        //默认显示mask
        hasMask: true,

        // 简单的动画效果 none | fade
        effect: null,

        // 模态遮蔽层的样式
        // 出自: http://dpl.aliui.com/?cat=43
        modal: {
            backgroundColor: '#EDF1F5',
            opacity: 0.7
        },

        // 不用 '' 是表示不要关闭, 所以要用空格表示可以关闭!
        closeTpl: ' ',

        // 语法糖
        size: {
            value: null,
            getter: function () {
                return [this.get('width'), this.get('height')];
            },
            setter: function (val) {
                this.set('width', val[0]).set('height', val[1]);
            }
        },

        // 默认模板，尽量不要覆盖
        template: require('./src/js/dialog.tpl'),

        // 自适应最大尺寸（maxHeight），默认为true
        // 见http://dpl.aliui.com/?p=1381 四、Windows弹框最大尺寸
        fixMaxSize: true,

        // 开启 fixMaxSize 之后 content 的最小高度
        fixMinHeight: 40,
        animation: {
            'in': 'fadeIn',
            'out': 'fadeOut'
        }
    },

    templateHelpers: {
        // 如果对应的属性为''表示不需要该区域
        // 目前适用属性 title, content
        has: function (attr, options) {
            return !attr ? "" : options.fn(this);
        },

        // 构建buttons区域的html的help方法
        buttonsHelp: function (buttons, options) {
            return buttons.length === 0 ? '' : options.fn(this);
        },

        // 构建button的html方法，主要考虑i18n
        htmlHelp: function (buttons, i18n, options) {
            var i, l, name;

            for (i = 0, l = buttons.length; i < l; i++) {
                // 用正则是为了处理xAlert方法里的特殊button，蛋疼吧！！！
                /*buttons[i].html = buttons[i].html.replace(new RegExp('{{(\\w+)}}'), function(){
                 return i18n[arguments[1]];
                 });*/
                name = buttons[i].name;
                buttons[i].html = buttons[i].html.replace('{{' + name + '}}', i18n[name]);
            }

            return options.fn(this);
        }
    },

    events: {
        'click [data-role=confirm]': function (ev) {
            this.trigger('confirm');
            ev.preventDefault();
        },
        'click [data-role=cancel]': function (ev) {
            this.trigger('cancel');
            ev.preventDefault();
            this.hide();
        },
        'click [data-role=yes]': function (ev) {
            this.trigger('confirm');
            ev.preventDefault();
        },
        'click [data-role=no]': function (ev) {
            this.trigger('no');
            ev.preventDefault();
            this.hide();
        },
        'click [data-role=close]': function (e) {
            e.preventDefault();
            this.trigger('close');
            this.hide();
        }
    },

    /**
     * 属性的初始化
     *
     * @method initAttrs
     * @protected
     */
    initAttrs: function (config) {
        Dialog.superclass.initAttrs.apply(this, arguments);


        // 构建model
        this._initModel();
    },

    // 重写，DialogBase的设定不是非常通用
    parseElement: function () {
        this.set("model", {
            classPrefix: this.get('classPrefix')
        });
        Dialog.superclass.parseElement.call(this);


        this.contentElement = this.$('[data-role=content]');

        // 必要的样式
        this.contentElement.css({
            height: '100%',
            zoom: 1
        });
        // 关闭按钮先隐藏
        // 后面当 onRenderCloseTpl 时，如果 closeTpl 不为空，会显示出来
        // 这样写是为了回避 arale.base 的一个问题：
        // 当属性初始值为''时，不会进入 onRender 方法
        // https://github.com/aralejs/base/issues/7
        this.$('[data-role=close]').hide();
    },

    /**
     * Dialog的特殊初始化
     * 放在 initProps 方法里是因为 delegateEvents 方法在 widget 里的调用顺序
     * TODO: 想出更优雅的方式，在 setup 里调用
     *
     * @method initProps
     * @protected
     */
    initProps: function () {
        Dialog.superclass.initProps.call(this);

        this._setupButtons();
    },
    // override
    setup: function () {
        // 在 父级的 setup 之前是为了绑定 after show 的顺序问题
        if (this.get('fixMaxSize')) {
            var locked = false;
            this.delegateEvents($(window), 'resize', function () {
                /*if(!locked){
                 this._maxSizeHandle();
                 locked = true;
                 }

                 //if(!this._timer){
                 var _self = this;

                 clearTimeout(this._timer);
                 //_self._timer = 0;
                 this._timer = setTimeout(function(){
                 locked = false;
                 _self._maxSizeHandle();
                 }, 200);
                 //}*/
                this._maxSizeHandle();
            });

            this._canResize = this._type !== 'iframe';
            this.after('show', function () {
                if (this._canResize) {
                    this._maxSizeHandle();
                }
            });

            // iframe的情况要在 iframe 之后绑定事件
            this.on('complete:show', function () {
                // 使用原生 style.height 是为了不受 maxHeight 的影响
                var h = this.contentElement[0].style.height;

                if (h) {
                    this.iframe.css('height', h);
                    this._canResize = true;
                    this._maxSizeHandle();
                    this.setPosition();
                }
            });
        }

        Dialog.superclass.setup.call(this);

        this._setupTrigger();
        this._setupMask();
        //this._setupKeyEvents();
        this._setupKeys();
        this._setupFocus();
        toTabed(this.element);
        toTabed(this.get('trigger'));

        // 默认当前触发器
        this.activeTrigger = this.get('trigger').eq(0);

        this._setupEvents();
    },
    show: function () {
        // iframe 要在载入完成才显示
        if (this._type === 'iframe') {
            // iframe 还未请求完，先设置一个固定高度
            !this.get('height') &&
            this.contentElement.css('height', this.get('initialHeight'));
            this._showIframe();
        }

        this.isShown = true;

        Dialog.superclass.show.call(this);
        //this.animate('in');

        return this;
    },

    hide: function () {
        // 把 iframe 状态复原
        if (this._type === 'iframe' && this.iframe) {
            this.iframe.attr({
                src: 'javascript:\'\';'
            });
            // 原来只是将 iframe 的状态复原
            // 但是发现在 IE6 下，将 src 置为 javascript:''; 会出现 404 页面
            this.iframe.remove();
            this.iframe = null;
        }
        this.isShown = false;

        //由于 animate 是异步, 故在 hide 执行完后, 动画并没有执行完毕,
        //Dialog 的 hide 处理实际并未完成, 可能会导致 hide 回调操作出现问题.
        //通过单测发现
        //this.animate('out').then(function () {
        Dialog.superclass.hide.call(this);

        clearInterval(this._interval);
        delete this._interval;
        //});
        return this;
    },

    destroy: function () {
        if (this.isShown === true) {
            //issue #11 : hide方法会调用_hideMask(), 所以这里会重复调用，导致bug
            // this._hideMask();
            this.hide();
        }

        this.element.remove();

        clearInterval(this._interval);
        return Dialog.superclass.destroy.call(this);
    },


    _onRenderCloseTpl: function (val) {
        if (val === '') {
            this.$('[data-role=close]').html(val).hide();
        } else {
            this.$('[data-role=close]').html(val).show();
        }
    },

    // 覆盖 overlay，提供动画
    _onRenderVisible: function (val) {
        if (val) {
            if (this.get('effect') === 'fade') {
                // 固定 300 的动画时长，暂不可定制
                this.element.fadeIn(300);
            } else {
                this.element.show();
                this._resetContentHeight();
            }
        } else {
            this.element.hide();
        }
    },
    _resetContentHeight: function(){
        if(this.get('contentHeight') != '100%' && this.contentElement.height() > Number(this.get('contentHeight'))){
            this.contentElement.css('overflow-y','scroll').css('height',this.get('contentHeight'));
        }
    },

    // 私有方法
    // ---

    // 绑定触发对话框出现的事件
    _setupTrigger: function () {
        this.delegateEvents(this.get('trigger'), 'click', function (e) {
            e.preventDefault();
            // 标识当前点击的元素
            this.activeTrigger = $(e.currentTarget);
            this.show();
        });
    },


    // 隐藏 mask
    _hideMask: function () {
        if (!this.get('hasMask')) {
            return;
        }

        mask._dialogs && mask._dialogs.pop();
        if (mask._dialogs && mask._dialogs.length > 0) {
            var last = mask._dialogs[mask._dialogs.length - 1];
            mask.set('zIndex', last.get('zIndex'));
            mask.element.insertBefore(last.element);
        } else {
            mask.hide();
        }
    },

    // 绑定元素聚焦状态
    // 使用UIState代替
    _setupFocus: function () {
        Util.deprecated('_setupFocus', 'Alpha-mixin/ui-state', '^0.1.0');
        this.after('show', function () {
            //this.element.focus();
            //UIState
            this.set('focused', this.get('autoFocus'));
            this.set('visible', true);
        });
        this.after('hide', function () {
            // 关于网页中浮层消失后的焦点处理
            // http://www.qt06.com/post/280/
            //this.activeTrigger && this.activeTrigger.focus();
            //UIState
            this.set('focused', false);
            this.set('visible', false);
        });
    },

    // 绑定键盘事件，ESC关闭窗口
    // 使用alpha-mixin/key-binder实现
    _setupKeyEvents: function () {
        Util.deprecated('_setupKeyEvents', 'Alpha-mixin/key-binder', '^0.1.0');
        if (this.get('supportKeyEvents')) {
            //this.delegateEvents($(document), 'keyup', function(e) {
            //    if (e.keyCode === 27) {
            //        this.get('visible') && this.hide();
            //    }
            //});
        }
    },
    _setupKeys: function () {
        var self = this;
        if (this.get('supportKeyEvents')) {
            this.keyBinderNode = $(document);
            this.keyBinder = {
                'esc': function () {
                    self.get('visible') && self.hide();
                },
                'enter': function () {
                    self.get('visible') && self.hide();
                }
            };
        }
    },

    _showIframe: function () {
        var that = this;
        // 若未创建则新建一个
        if (!this.iframe) {
            this._createIframe();
        }
        // 开始请求 iframe
        this.iframe.attr({
            src: this._fixUrl(),
            name: 'dialog-iframe' + new Date().getTime()
        });
        // 因为在 IE 下 onload 无法触发
        // http://my.oschina.net/liangrockman/blog/24015
        // 所以使用 jquery 的 one 函数来代替 onload
        // one 比 on 好，因为它只执行一次，并在执行后自动销毁
        this.iframe.one('load', function () {
            // 如果 dialog 已经隐藏了，就不需要触发 onload
            if (!that.get('visible')) {
                return;
            }
            // 绑定自动处理高度的事件
            if (that.get('autoFit')) {
                clearInterval(that._interval);
                that._interval = setInterval(function () {
                    that._syncHeight();
                }, 300);
            }
            that._syncHeight();
            that.setPosition();
            that.trigger('complete:show');
        });
    },

    _fixUrl: function () {
        var s = this.get('content').match(/([^?#]*)(\?[^#]*)?(#.*)?/);
        s.shift();
        s[1] = ((s[1] && s[1] !== '?') ? (s[1] + '&') : '?') +
            't=' + new Date().getTime();
        return s.join('');
    },

    _createIframe: function () {
        var that = this;

        this.iframe = $('<iframe>', {
            src: 'javascript:\'\';',
            scrolling: that.get('iframeScrolling'),
            frameborder: 'no',
            allowTransparency: 'true',
            css: {
                border: 'none',
                width: '100%',
                display: 'block',
                height: '100%'
                //"overflow-x": that.get('iframeOverflowX'),
                //"overflow-y": that.get('iframeOverflowY')
            }
        }).appendTo(this.contentElement);

        // 给 iframe 绑一个 close 事件
        // iframe 内部可通过 window.frameElement.trigger('close') 关闭
        Events.mixTo(this.iframe[0]);
        this.iframe[0].on('close', function () {
            that.hide();
        });
    },

    _syncHeight: function () {
        var h;
        // 如果未传 height，才会自动获取
        if (!this.get('height')) {
            try {
                this._errCount = 0;
                h = getIframeHeight(this.iframe) + 'px';
                // console.log('h_dom', h , 'h_jq', $(this.iframe).height());
            } catch (err) {
                // 页面跳转也会抛错，最多失败6次
                this._errCount = (this._errCount || 0) + 1;
                if (this._errCount >= 6) {
                    // 获取失败则给默认高度 300px
                    // 跨域会抛错进入这个流程
                    h = this.get('initialHeight');
                    clearInterval(this._interval);
                    delete this._interval;
                }
            }
            this.contentElement.css('height', h);
            // force to reflow in ie6
            // http://44ux.com/blog/2011/08/24/ie67-reflow-bug/
            this.element[0].className = this.element[0].className;
            clearInterval(this._interval);
        } else {
            // 如果用户指定height，则使用该高度
            this.contentElement.css('height', this.get('height'));
            clearInterval(this._interval);
            delete this._interval;
        }
    },

    /**
     * Dialog 重定位
     * 无论窗体尺寸如何改变，让弹窗回到原始定义的位置上
     *
     * @method initProps
     * @protected
     */
    reposition: function () {
        if (this._canResize) {
            this._maxSizeHandle();
        }
        this.setPosition();
    },

    /**
     * Dialog下对mask的特殊初始化, 绑定遮罩层事件
     * overwrite
     *
     * @method setup
     * @protected
     */
    _setupMask: function () {
        var that = this;

        // 存放 mask 对应的对话框
        mask._dialogs = mask._dialogs || [];

        this.after('show', function () {
            if (!this.get('hasMask')) {
                return;
            }
            // not using the z-index
            // because multiable dialogs may share same mask
            mask.set('zIndex', that.get('zIndex')).show();
            mask.element.insertBefore(that.element);

            // 避免重复存放
            var existed = false;
            for (var i = 0; i < mask._dialogs.length; i++) {
                if (mask._dialogs[i] === that) {
                    existed = true;
                }
            }
            // 依次存放对应的对话框
            if (!existed) {
                mask._dialogs.push(that);
            }
        });

        this.after('hide', this._hideMask);


        this.before('show', function () {
            var modal = this.get('modal');

            if (this.get('hasMask')) {
                // 如果有设置modal的样式，就改变之再显示
                if (!isBoolean(modal)) {
                    mask.set(modal);
                }
            }
        });
    },

    _maxSizeHandle: function () {
        this.contentElement.css('maxHeight', 'none');

        var height = this.element.outerHeight();
        var winHeight = $(window).height();

        if (height + 100 > winHeight) {
            var maxHeight = winHeight - 100 - (height - this.contentElement.height());

            // 有最小高度的限制
            var fixMinHeight = this.get('fixMinHeight');
            if (maxHeight < fixMinHeight) {
                maxHeight = fixMinHeight;
            }

            this.contentElement.css('maxHeight', maxHeight)
                .css('overflowY', 'auto')
                .css('overflowX', 'hidden');
            //.css('height', 'auto');
        }
    },

    // 为了将来做兼容
    _setupEvents: function() {
        // TIP: alpha-base中已增加对attrs中定义的on/after/before等监听事件的处理，这里就不需要重复增加了。
        // if (this.get('afterHide')) {
        //     this.after('hide', this.get('afterHide'));
        // }

        // if (this.get('afterShow')) {
        //     this.after('show', this.get('afterShow'));
        // }

        // if (this.get('onConfirm')) {
        //     this.on('confirm', this.get('onConfirm'));
        // }
    },

    /**
     * 构建model
     *
     * @method _initModel
     * @private
     */
    _initModel: function () {
        var model = {},
            i, l;

        // 从Attrs中读取数据
        for (i = 0, l = setModelFromAttrs.length; i < l; i++) {
            model[setModelFromAttrs[i]] = this.get(setModelFromAttrs[i]);
        }

        // 做 content 为 url 时的兼容处理
        if (this._type == 'iframe') {
            model.content = '';
        }

        // 设置model
        this.set('model', model);
    },

    //-----------UI处理
    _onRenderTitle: function (val) {
        this.$('[data-role=title]').html(val);
    },

    // override 降级：不支持 选择器 来规避 jquery 1.8.3 的bug
    _onRenderContent: function (val) {
        //if (this._type !== 'iframe') {
        //    var value;
        //    // 有些情况会报错
        //    try {
        //        value = $(val);
        //    } catch (e) {
        //        value = [];
        //    }
        //    if (value[0]) {
        //        this.contentElement.empty().append(value);
        //    } else {
        //        this.contentElement.empty().html(val);
        //    }
        //    // #38 #44
        //    this.setPosition();
        //}

        if (this._type !== 'iframe') {
            this.contentElement.empty().html(val);
            this.reposition();
        }
    }
});

//-----------Statics
// 实例缓存
var inc,
    emptyFn = function () {
    },
    destroyInc = function () {
        var _self = this;

        setTimeout(function () {
            //_self.off();
            _self.destroy();
            inc = null;
        }, 150);
    };

/**
 * alert的UI模拟
 *
 * @method Dialog.xAlert
 * @param config {Object} 配置
 * @param config.title {String|Function} 标题区域的内容
 * @param config.content {String|Function} 内容区域的内容
 * @param config.callback {Function} 点击确认时触发的回调
 * @param config.effect {Object} 动画效果
 * @param config.showEffect {Object} 动画效果
 * @param config.hideEffect {Object} 动画效果
 * @static
 */
Dialog.xAlert = function (config) {
    var callback = config.callback || emptyFn;

    // 写button
    /*config.buttons = [{
     name: 'confirm',
     html: buttonMap['confirm']
     }];*/
    config.buttons = ['confirm'];

    // 保证只有一个实例
    if (inc) {
        inc.hide();
    }

    inc = new Dialog(config)
    // 绑定 callback
        .on('confirm', function () {
            callback.call(this);
            this.hide();
        })
        .show()
        .after('hide', destroyInc);
};

/**
 * confirm的UI模拟
 *
 * @method Dialog.xConfirm
 * @param config {Object} 配置
 * @param config.title {String|Function} 标题区域的内容
 * @param config.content {String|Function} 内容区域的内容
 * @param config.callback {Function} 点击按钮时触发的回调
 * @param config.buttonType {String} 按钮的文案差异，实际内容相同，只支持'yes'及'confirm'2种输入，默认'confirm'
 * @param config.effect {Object} 动画效果
 * @param config.showEffect {Object} 动画效果
 * @param config.hideEffect {Object} 动画效果
 * @static
 */
Dialog.xConfirm = function (config) {
    var callback = config.callback || emptyFn,
        afterHide = config.afterHide || emptyFn,
        ret = false;

    // 写button
    config.buttons = config.buttonType === 'yes' ? ['yes', 'no'] : ['confirm', 'cancel'];
    delete config.buttonType;

    // 保证只有一个实例
    if (inc) {
        inc.hide();
    }

    delete config.afterHide;

    inc = new Dialog(config)
        .on('confirm', function () {
            ret = true;
            this.hide();
        })
        .after('hide', function () {
            callback.call(this, ret);
            callback = emptyFn;
            // 为了保证 afterHide 是在 callback 之后触发
            afterHide.call(this);
        })
        .show()
        .after('hide', destroyInc);
};

module.exports = Dialog;


//-----------Helper

function isBoolean(val) {
    return typeof val === 'boolean';
}

// 简单合并文案用
function merge(one, two) {
    var ret = {},
        key;

    for (key in one) {
        if (one.hasOwnProperty(key)) {
            ret[key] = two[key] || one[key];
        }
    }

    return ret;
}

// Helpers
// ----

// 让目标节点可以被 Tab
function toTabed(element) {
    if (element.attr('tabindex') == null) {
        element.attr('tabindex', '-1');
    }
}

// 获取 iframe 内部的高度
function getIframeHeight(iframe) {
    var D = iframe[0].contentWindow.document;
    if (D.body.scrollHeight && D.documentElement.scrollHeight) {
        return Math.min(
            D.body.scrollHeight,
            D.documentElement.scrollHeight
        );
    } else if (D.documentElement.scrollHeight) {
        return D.documentElement.scrollHeight;
    } else if (D.body.scrollHeight) {
        return D.body.scrollHeight;
    }
}
